var map = {
	"./cagayan-cert.webp": 1951,
	"./cert-bg.webp": 1952,
	"./isle-cert.webp": 1953,
	"./license-bg-cn.webp": 1954,
	"./license-bg-mobile-cn.webp": 1955,
	"./license-bg-mobile.webp": 1956,
	"./license-bg.webp": 1957,
	"./pagcor-cert.webp": 1958,
	"./page-bg.webp": 1959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 876;